module.exports = __webpack_public_path__ + "static/media/kverneland-slogan.f7426823.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/kverneland-slogan.png
// module id = 408
// module chunks = 2